import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { IModalHeader, IModalParams, TranslateService } from '@devinforius/i-essentials';
import moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { TreeSelect } from 'primeng/treeselect';
import { ClassificationCodeDto, DropdownService, NatureDto, SourceDto } from 'src/app/shared/interfaces';
import { ServicesService } from 'src/app/shared/services/services.service';
import * as _ from 'underscore';
import { SourcesService } from 'src/app/shared/services/sources.service';
import { GlobalCentreNumerisationDTO } from 'src/app/shared/models/iCourrier/centre-numerisation/global-centre-numerisation';
import { UsersService } from 'src/app/shared/services/users.service';
import { UserDto } from 'src/app/shared/interfaces/users';
import { ClassificationsService } from 'src/app/shared/services/classifications.service';
import { NaturesService } from 'src/app/shared/services/natures.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { NumerisationCentersService } from 'src/app/shared/services/numerisation_centers.service';
import { ServicesOnlyParent } from 'src/app/shared/models/iCourrier/service';
import { MassEncodeDisplayedDatas } from 'src/app/shared/interfaces/scans/mass-encode-datas';
import {
  manageServicesSetAsTreeSelect,
  manageServicesToBeMerged,
  returnOnlyParentServices,
} from 'src/app/shared/utils/manage-services-for-tree-select.utils';
import { ScanSplit } from '@devinforius/i-scan';
import { UserContact } from 'src/app/shared/models';
import { catchError, forkJoin, of } from 'rxjs';

@Component({
  selector: 'app-mass-encode-scans',
  templateUrl: './mass-encode-scans.component.html',
  styleUrls: ['./mass-encode-scans.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MassEncodeScansComponent implements OnInit {
  @ViewChild('treeSelect') treeSelect: TreeSelect;

  @Input() splits: ScanSplit[];
  @Input() showAllServices: boolean;
  @Output() public closeModal: EventEmitter<{ splits: ScanSplit[]; displayedValues: MassEncodeDisplayedDatas[]; formValue }> = new EventEmitter();

  // Form for the 1st part of the modal
  public form: UntypedFormGroup = new UntypedFormGroup({
    dateEntree: new UntypedFormControl(null, Validators.required),
    dateDocument: new UntypedFormControl(null),
    dateEcheance: new UntypedFormControl(null),
    datePostale: new UntypedFormControl(null),
    remarques: new UntypedFormControl(null),
  });
  public maxDateModified = moment().toDate();
  public maxDate = moment().toDate();

  public selectedOption = null; // Service selected
  public selectedCard: MassEncodeDisplayedDatas = null; // Selected line in the table
  public selectedCards: MassEncodeDisplayedDatas[] = null; // Selected lines in the table (multi selection)
  public displayedValues: MassEncodeDisplayedDatas[] = [];

  public chosenSource: number;
  public chosenRecommendedRef: string;
  public chosenScanningCenter: string;
  public chosenNature: number;
  public chosenRecipient: number;
  public chosenClassificationCode;
  public showRecommendedRef: boolean;

  public services;
  public servicesFusionned: {
    label: string;
    value: number;
    id: number;
    parentId: number;
    name: string;
    key: string;
    selectable: boolean;
    children: [];
  }[] = [];
  public servicesOnlyParent: ServicesOnlyParent[] = [];
  public natures: {
    label: string;
    value: number;
  }[] = [];
  public sources: {
    label: string;
    value: number;
    afficherReferenceRecommande: boolean;
  }[] = [];
  public recipients: UserContact[];
  public classificationCodes: { label: string; value: number }[] = [];
  public scanningCenters: GlobalCentreNumerisationDTO[];

  public translationPlaceholderPTree: string;

  public openModificationCardModal = false;
  public modalHeaderModificationCard: IModalHeader = {
    title: 'iScan.action.processOneMail',
    showNotification: false,
    showParameters: false,
    closable: true,
  };
  public modalParamsModificationCard: IModalParams = {
    isDraggable: false,
    isResizable: true,
    isModal: true,
  };

  public listOfIndexCardsSelected: boolean[] = [];
  public allCardsSelected = false;

  public isLoaded = false;
  constructor(
    private translater: TranslateService,
    private toastr: ToastrService,
    private servicesService: ServicesService,
    private sourcesService: SourcesService,
    private usersService: UsersService,
    private classificationService: ClassificationsService,
    private naturesService: NaturesService,
    private numerisationCentersService: NumerisationCentersService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.setTranslations();
    this.setDatas();
  }

  setTranslations(): void {
    this.translationPlaceholderPTree = this.translater.translate('pleaseSelectAService');
    this.modalHeaderModificationCard.title = this.translater.translate(this.modalHeaderModificationCard.title);
  }

  private setDatas(): void {
    forkJoin({
      services: this.servicesService.fetchMappedServicesToPrimeNGDropdowns().pipe(
        catchError(() => {
          console.error('Erreur lors de la récupération des services');
          return of([]);
        })
      ),
      natures: this.naturesService.fetchNatures().pipe(
        catchError(() => {
          console.error('Erreur lors de la récupération des natures');
          return of([]);
        })
      ),
      sources: this.sourcesService.fetchSources().pipe(
        catchError(() => {
          console.error('Erreur lors de la récupération des sources');
          return of([]);
        })
      ),
      recipients: this.usersService.fetchUsersFromiAdmin({ Active: true }).pipe(
        catchError(() => {
          console.error('Erreur lors de la récupération des destinataires');
          return of([]);
        })
      ),
      classifications: this.classificationService.fetchClassificationCodes(true).pipe(
        catchError(() => {
          console.error('Erreur lors de la récupération des codes de classements');
          return of([]);
        })
      ),
      numerizationCenters: this.numerisationCentersService.getGlobalCentreNumerisation().pipe(
        catchError(() => {
          console.error('Erreur lors de la récupération des centres de numerisation');
          return of([]);
        })
      ),
    }).subscribe({
      next: (response) => {
        this.formatServices(response.services);
        this.formatNatures(response.natures);
        this.formatSources(response.sources);
        this.formatRecipients(response.recipients);
        this.formatClassifications(response.classifications);
        this.formatNumerizationCenters(response.numerizationCenters);
        this.form.patchValue({
          dateEntree: moment().toDate(),
        });
        this.setDatasForCardsDisplayed();
      },
    });
  }

  private formatServices(servicesReceived: DropdownService[]): void {
    const datasForService = manageServicesSetAsTreeSelect(servicesReceived, this.translater);
    this.services = datasForService.servicesForSingleCheck;
    this.servicesOnlyParent = returnOnlyParentServices(servicesReceived);
    this.servicesFusionned = manageServicesToBeMerged(servicesReceived);
  }

  private formatNatures(natures: NatureDto[]): void {
    this.natures = [];
    natures.forEach((nature) => {
      this.natures.push({
        label: nature.description,
        value: nature.id,
      });
    });
    this.natures = _.sortBy(this.natures, 'label');
  }

  private formatSources(sources: SourceDto[]): void {
    this.sources = [];
    sources.forEach((source) => {
      this.sources.push({
        label: source.description,
        value: source.id,
        afficherReferenceRecommande: source.afficherReferenceRecommande,
      });
    });
    this.sources = _.sortBy(this.sources, 'label');
  }

  private formatRecipients(recipients: UserDto[]): void {
    this.recipients = [];
    recipients.forEach((user) => {
      this.recipients.push(new UserContact(user));
    });
  }

  private formatClassifications(classifications: ClassificationCodeDto[]): void {
    this.classificationCodes = [];
    classifications.forEach((classement) => {
      this.classificationCodes.push({
        label: classement.code + (classement.description ? ' (' + classement.description + ')' : ''),
        value: classement.id,
      });
    });
    this.classificationCodes = _.sortBy(this.classificationCodes, 'label');
  }

  private formatNumerizationCenters(numerizationCenters: GlobalCentreNumerisationDTO[]): void {
    this.scanningCenters = numerizationCenters;
  }

  private setDatasForCardsDisplayed(): void {
    this.splits.forEach((split, splitIndex) => {
      if (!split.lock) {
        // Pour chaque split NON LOCK, on va récupérer le QRCode ainsi que les données lui étant liées
        // un split lock signifie qu'un courrier a déjà été créé
        const qrCode = this.explodeQrCode(split.mainCode);

        const serviceId = this.extractQrCodeDataFromArray(qrCode, 'SVCID') ? +this.extractQrCodeDataFromArray(qrCode, 'SVCID') : null;
        const sourceId = this.extractQrCodeDataFromArray(qrCode, 'SRCID') ? +this.extractQrCodeDataFromArray(qrCode, 'SRCID') : null;
        const scanningCenterKey = this.extractQrCodeDataFromArray(qrCode, 'CENTERNUM')
          ? this.extractQrCodeDataFromArray(qrCode, 'CENTERNUM').toString()
          : null;
        const recipientId = this.extractQrCodeDataFromArray(qrCode, 'DESTCNTID') ? +this.extractQrCodeDataFromArray(qrCode, 'DESTCNTID') : null;
        const classificationCodeId = this.extractQrCodeDataFromArray(qrCode, 'CODECLASSID')
          ? +this.extractQrCodeDataFromArray(qrCode, 'CODECLASSID')
          : null;

        const dataForCard: MassEncodeDisplayedDatas = {
          splitIndex: splitIndex,
          courrierIndex: splitIndex + 1,
          serviceId: serviceId,
          serviceLabel: serviceId ? this.servicesFusionned.find((x) => x.value === serviceId)?.label : '',
          natureId: null,
          natureLabel: null,
          sourceId: sourceId,
          sourceLabel: sourceId ? this.sources.find((x) => x.value === sourceId)?.label : '',
          recommendedRef: '',
          scanningCenter: scanningCenterKey,
          scanningCenterLabel: scanningCenterKey
            ? this.scanningCenters.find((scanningCenter) => scanningCenter.codeQr === scanningCenterKey)?.description
            : '',
          recipientId: recipientId,
          recipientLabel: recipientId ? this.recipients.find((x) => x.contactId === recipientId)?.name : '',
          classificationCodeId: classificationCodeId,
          classificationCodeLabel: this.classificationCodes.find((x) => x.value === classificationCodeId)?.label,
        };
        this.displayedValues.push(dataForCard);
      }
    });
    // like for the service we need to set Visibility to true, then we need to force the array to know it has changed for the table to display it
    this.displayedValues = [...this.displayedValues];
    this.listOfIndexCardsSelected = new Array(this.displayedValues.length).fill(false);
    this.isLoaded = true;
  }

  public explodeQrCode(qrCode): Array<{ tag: string; content: string }> {
    if (qrCode) {
      const regexp = /<([^>]+)>(.*?)<\/\1>/g;
      const resultsObtained = [];
      let match;
      while ((match = regexp.exec(qrCode)) !== null) {
        const tag = match[1]; // La balise trouvée
        const content = match[2]; // Le contenu entre les balises
        resultsObtained.push({ tag: tag, content: content });
      }
      return resultsObtained;
    } else return [];
  }

  public extractQrCodeDataFromArray(
    array: Array<{ tag: string; content: string }>,
    type: 'SVCID' | 'CENTERNUM' | 'SRCID' | 'CODECLASSID' | 'DESTCNTID'
  ): string | number | null {
    if (array?.length > 0 && type) {
      const dataToExtract = array.find((x) => x.tag === type);
      if (dataToExtract) {
        if (type === 'SVCID') {
          this.selectedOption = _.first(this.servicesFusionned.filter((x) => x.value === +dataToExtract.content));
          if (!this.showAllServices) {
            //Si on n'affiche pas les services enfants alors faut remonter jusqu'au parent 0
            if (this.selectedOption.parentId > 0) {
              const parentOriginal = this.getBackToOriginalParent(this.selectedOption);
              this.selectedOption = parentOriginal;
              return parentOriginal.value;
            } else {
              return dataToExtract.content;
            }
          } else {
            return dataToExtract.content;
          }
        } else {
          return dataToExtract.content;
        }
      } else {
        return null;
      }
    } else return null;
  }

  /**
   * getBackToOriginalParent
   * @description
   *  Go back to the original parent of a service from the fusionned list
   *  This is useful when we want to get the original parent of a service because
   *  we have a list of services that have been fusionned on multiple levels
   * @param {label:string, value : number, parentId: number} item - Item to
   *  get the original parent from
   * @returns {{label:string, value : number, parentId: number}} - The original
   *  parent of the item
   */
  public getBackToOriginalParent(item: { label: string; value: number; parentId: number }): {
    label: string;
    value: number;
    parentId: number;
  } {
    const parent = _.first(this.servicesFusionned.filter((x) => x.value === item.parentId));
    if (parent.parentId > 0) {
      return this.getBackToOriginalParent(parent);
    } else {
      return parent;
    }
  }

  public selectUnselectCardsTooltip(): string {
    return this.allCardsSelected ? this.translater.translate('iScan.action.unselectAll') : this.translater.translate('iScan.action.selectAll');
  }

  public selectUnselectAllCards(): void {
    if (this.allCardsSelected) {
      this.listOfIndexCardsSelected = new Array(this.displayedValues.length).fill(false);
      this.allCardsSelected = false;
    } else {
      this.listOfIndexCardsSelected = new Array(this.displayedValues.length).fill(true);
      this.allCardsSelected = true;
    }
  }

  public isAnyScanSelected(): boolean {
    return this.listOfIndexCardsSelected?.find((x) => x === true);
  }

  public modifyListOfCheckedCards(index: number): void {
    this.listOfIndexCardsSelected[index] = !this.listOfIndexCardsSelected[index];

    if (this.listOfIndexCardsSelected.every((bool) => bool === false)) {
      this.allCardsSelected = false;
    } else if (this.listOfIndexCardsSelected.every((bool) => bool === true)) {
      this.allCardsSelected = true;
    }
  }

  public modifySingleCard(value: MassEncodeDisplayedDatas): void {
    this.openModificationCardModal = true;
    this.spinner.show();
    this.selectedCard = value;
    this.selectedCards = [];
    if (value.sourceId) {
      this.chosenSource = value.sourceId;
      this.changeSource({ value: value.sourceId });
    } else {
      this.chosenSource = null;
      this.showRecommendedRef = false;
    }
    this.chosenScanningCenter = value.scanningCenter ? value.scanningCenter : null;
    this.chosenRecipient = value.recipientId ? value.recipientId : null;
    this.chosenRecommendedRef = value.recommendedRef ? value.recommendedRef : null;
    this.chosenClassificationCode = value.classificationCodeId ? value.classificationCodeId : null;
    this.chosenNature = value.natureId ? value.natureId : null;

    if (value.serviceId) {
      setTimeout(() => {
        this.patchServiceOnLoopInTreeSelect(value.serviceId, value.serviceLabel);
        this.selectedOption = _.first(this.servicesFusionned.filter((x) => x.value === value.serviceId));
        this.spinner.hide();
      }, 500);
    } else {
      setTimeout(() => {
        this.select(null);
        this.spinner.hide();
      }, 500);
    }
  }

  public modifyListOfCards(listOfScansBooleanCheck: boolean[]): void {
    this.openModificationCardModal = true;
    this.spinner.show();
    this.selectedCard = null;
    this.selectedCards = [];
    listOfScansBooleanCheck.forEach((cardBoolean, index) => {
      cardBoolean ? this.selectedCards.push(this.displayedValues[index]) : null;
    });

    // Ici on va faire les vérification afin de patcher uniquement les données qui sont communes à tous les cards
    this.patchSourceMultiModificationCards();
    this.patchScanningCenterMultiModificationCards();
    this.patchRecipientMultiModificationCards();
    this.patchRecommendedRefMultiModificationCards();
    this.patchClassificationCodeMultiModificationCards();
    this.patchNatureMultiModificationCards();
    this.patchServiceMultiModificationCards();
  }

  private patchSourceMultiModificationCards(): void {
    // D'abord on récupère la première source non nulle
    const firstNonEmptySourceId = this.selectedCards.find((card) => card.sourceId !== null && card.sourceId !== undefined);
    // S'il en existe une, on va vérifier si elles sont toutes identiques
    if (firstNonEmptySourceId) {
      const allSameSourceId = this.selectedCards.every((card) => card.sourceId === firstNonEmptySourceId.sourceId);
      // Si elles sont toutes identiques, on va patcher la source
      if (allSameSourceId) {
        this.chosenSource = firstNonEmptySourceId.sourceId;
        this.changeSource({ value: firstNonEmptySourceId.sourceId });
      } else {
        this.chosenSource = null;
        this.showRecommendedRef = false;
      }
    } else {
      this.chosenSource = null;
      this.showRecommendedRef = false;
    }
  }

  private patchScanningCenterMultiModificationCards(): void {
    const firstNonEmptyScanningCenter = this.selectedCards.find((card) => card.scanningCenter !== null && card.scanningCenter !== undefined);
    if (firstNonEmptyScanningCenter) {
      const allSameScanningCenter = this.selectedCards.every((card) => card.scanningCenter === firstNonEmptyScanningCenter.scanningCenter);
      if (allSameScanningCenter) {
        this.chosenScanningCenter = firstNonEmptyScanningCenter.scanningCenter;
      } else {
        this.chosenScanningCenter = null;
      }
    } else {
      this.chosenScanningCenter = null;
    }
  }

  private patchRecipientMultiModificationCards(): void {
    const firstNonEmptyRecipient = this.selectedCards.find((card) => card.recipientId !== null && card.recipientId !== undefined);
    if (firstNonEmptyRecipient) {
      const allSameRecipient = this.selectedCards.every((card) => card.recipientId === firstNonEmptyRecipient.recipientId);
      if (allSameRecipient) {
        this.chosenRecipient = firstNonEmptyRecipient.recipientId;
      } else {
        this.chosenRecipient = null;
      }
    } else {
      this.chosenRecipient = null;
    }
  }

  private patchRecommendedRefMultiModificationCards(): void {
    const firstNonEmptyRecommendedRef = this.selectedCards.find((card) => card.recommendedRef !== null && card.recommendedRef !== undefined);
    if (firstNonEmptyRecommendedRef) {
      const allSameRecommendedRef = this.selectedCards.every((card) => card.recommendedRef === firstNonEmptyRecommendedRef.recommendedRef);
      if (allSameRecommendedRef) {
        this.chosenRecommendedRef = firstNonEmptyRecommendedRef.recommendedRef;
      } else {
        this.chosenRecommendedRef = null;
      }
    } else {
      this.chosenRecommendedRef = null;
    }
  }

  private patchClassificationCodeMultiModificationCards(): void {
    const firstNonEmptyClassificationCode = this.selectedCards.find(
      (card) => card.classificationCodeId !== null && card.classificationCodeId !== undefined
    );
    if (firstNonEmptyClassificationCode) {
      const allSameClassificationCode = this.selectedCards.every(
        (card) => card.classificationCodeId === firstNonEmptyClassificationCode.classificationCodeId
      );
      if (allSameClassificationCode) {
        this.chosenClassificationCode = firstNonEmptyClassificationCode.recommendedRef;
      } else {
        this.chosenClassificationCode = null;
      }
    } else {
      this.chosenClassificationCode = null;
    }
  }

  private patchNatureMultiModificationCards(): void {
    const firstNonEmptyNature = this.selectedCards.find((card) => card.natureId !== null && card.natureId !== undefined);
    if (firstNonEmptyNature) {
      const allSameNature = this.selectedCards.every((card) => card.natureId === firstNonEmptyNature.natureId);
      if (allSameNature) {
        this.chosenNature = firstNonEmptyNature.natureId;
      } else {
        this.chosenNature = null;
      }
    } else {
      this.chosenNature = null;
    }
  }

  private patchServiceMultiModificationCards(): void {
    const firstNonEmptyService = this.selectedCards.find((card) => card.serviceId !== null && card.serviceId !== undefined);
    if (firstNonEmptyService) {
      const allSameService = this.selectedCards.every((card) => card.serviceId === firstNonEmptyService.serviceId);
      if (allSameService) {
        setTimeout(() => {
          this.patchServiceOnLoopInTreeSelect(firstNonEmptyService.serviceId, firstNonEmptyService.serviceLabel);
          this.selectedOption = _.first(this.servicesFusionned.filter((x) => x.value === firstNonEmptyService.serviceId));
          this.spinner.hide();
        }, 500);
      } else {
        setTimeout(() => {
          this.select(null);
          this.spinner.hide();
        }, 500);
      }
    } else {
      setTimeout(() => {
        this.select(null);
        this.spinner.hide();
      }, 500);
    }
  }

  public getSelectedCardsIndexes(): string {
    return this.selectedCards.map((x) => x.courrierIndex).join(', ');
  }

  public changeSource(event): void {
    this.chosenSource = event.value;
    if (event?.value) {
      this.showRecommendedRef = this.sources.find((x) => x.value === event.value)?.afficherReferenceRecommande;
    } else {
      this.showRecommendedRef = false;
    }
    if (this.showRecommendedRef === false) {
      this.chosenRecommendedRef = '';
    }
  }

  public checkIfSomeSourceExist(): string {
    return this.sources.length > 0
      ? this.translater.translate('iScan.action.selectSource')
      : this.translater.translate('iScan.information.noSourceAvailable');
  }

  public changeMaxdateDocumentsClick(event): void {
    this.maxDateModified = moment(event, 'DD/MM/YYYY').toDate();
  }

  public changeMaxdateDocuments(event): void {
    if (moment(event.target.value, 'DD/MM/YYYY', true).isValid()) {
      this.maxDateModified = moment(event.target.value, 'DD/MM/YYYY').toDate();
    }
  }

  /**
   * * Method to add p-highlight class to current service selected
   */
  public onShowTreeSelect(): void {
    if (this.selectedOption) {
      const aTags = document.getElementsByClassName('p-treenode-content');
      let found;
      if (aTags && aTags.length > 0) {
        for (let i = 0; i < aTags.length; i++) {
          if (aTags[i].textContent == this.selectedOption.label) {
            found = aTags[i];
            found.classList.add('p-highlight');
            break;
          }
        }
      }
    }
  }

  public select(event): void {
    if (event?.node && event?.node?.value) {
      if (this.selectedOption?.value !== event.node.value) {
        this.selectedOption = _.first(this.servicesFusionned.filter((x) => x.value === event.node.value));
        const labelTreeHtml = document.getElementsByClassName('p-treeselect-label');
        labelTreeHtml[0].innerHTML = this.selectedOption.label;
      } else {
        this.selectedOption = null;
        const labelTreeHtml = document.getElementsByClassName('p-treeselect-label');
        labelTreeHtml[0].innerHTML = this.translationPlaceholderPTree;
        this.treeSelect.value = [];
      }
    } else {
      this.selectedOption = null;
      const labelTreeHtml = document.getElementsByClassName('p-treeselect-label');
      labelTreeHtml[0].innerHTML = this.translationPlaceholderPTree;
      this.treeSelect.value = [];
    }
  }

  public changeScanningCenter(event): void {
    this.chosenScanningCenter = event.value;
  }

  public checkIfSomeScanningCenterExist(): string {
    return this.scanningCenters.length > 0
      ? this.translater.translate('iScan.action.selectScanningCenter')
      : this.translater.translate('iScan.information.noScanningCenterAvailable');
  }
  public changeNature(event): void {
    this.chosenNature = event.value;
  }

  public checkIfSomeNatureExist(): string {
    return this.natures.length > 0
      ? this.translater.translate('iScan.action.selectNature')
      : this.translater.translate('iScan.information.noNatureAvailable');
  }

  public changeRecipient(event): void {
    this.chosenRecipient = event.value;
  }
  public checkIfSomeRecipientExist(): string {
    return this.recipients.length > 0
      ? this.translater.translate('iScan.action.selectRecipient')
      : this.translater.translate('iScan.information.noRecipientAvailable');
  }

  public changeClassificationCode(event): void {
    this.chosenClassificationCode = event.value;
  }

  public checkIfSomeClassificationCodeExist(): string {
    return this.classificationCodes.length > 0
      ? this.translater.translate('iScan.action.selectClassificationCode')
      : this.translater.translate('iScan.information.noClassificationCodeAvailable');
  }

  public onChangeRecommendedRef(event): void {
    this.chosenRecommendedRef = event.target.value;
  }

  public patchServiceOnLoopInTreeSelect(serviceChosen, labelToDisplay): void {
    this.services.map((parent) => {
      //si le parentId correspond on set
      if (parent.id === serviceChosen) {
        this.treeSelect.value = parent;
        const labelTreeHtml = document.getElementsByClassName('p-treeselect-label');
        labelTreeHtml[0].innerHTML = labelToDisplay;
      } else {
        //Si pas on va devoir entrer dans les enfants
        if (parent.children?.length > 0) {
          recursive(serviceChosen, parent.children, this.treeSelect.value, labelToDisplay);
        }
      }
    });
    //Array will always be length 1 here like we only send 1 id

    function recursive(serviceId, children, treeSelectValue, labelToDisplay): void {
      children.map((child) => {
        if (child.id === serviceId) {
          treeSelectValue = child;
          const labelTreeHtml = document.getElementsByClassName('p-treeselect-label');
          labelTreeHtml[0].innerHTML = labelToDisplay;
        } else {
          if (child.children && child.children.length > 0) {
            recursive(serviceId, child.children, treeSelectValue, labelToDisplay);
          }
        }
      });
    }
  }

  public modifyDatas(): void {
    this.openModificationCardModal = false;
    this.selectedCard = {
      splitIndex: this.selectedCard.splitIndex,
      courrierIndex: this.selectedCard.courrierIndex,
      serviceId: this.selectedOption?.value ? this.selectedOption.value : null,
      serviceLabel: this.selectedOption?.label ? this.selectedOption.label : null,
      natureId: this.chosenNature ? this.chosenNature : null,
      natureLabel: this.chosenNature ? this.natures.find((nature) => nature.value === this.chosenNature)?.label : '',
      sourceId: this.chosenSource ? this.chosenSource : null,
      sourceLabel: this.chosenSource ? this.sources.find((source) => source.value === this.chosenSource)?.label : '',
      recommendedRef: this.chosenRecommendedRef ? this.chosenRecommendedRef : null,
      scanningCenter: this.chosenScanningCenter ? this.chosenScanningCenter : null,
      scanningCenterLabel: this.chosenScanningCenter ? this.scanningCenters.find((x) => x.codeQr === this.chosenScanningCenter)?.description : '',
      recipientId: this.chosenRecipient ? this.chosenRecipient : null,
      recipientLabel: this.chosenRecipient ? this.recipients.find((x) => x.contactId === this.chosenRecipient)?.name : '',
      classificationCodeId: this.chosenClassificationCode ? this.chosenClassificationCode : null,
      classificationCodeLabel: this.chosenClassificationCode
        ? this.classificationCodes.find((classificationCode) => classificationCode.value === this.chosenClassificationCode)?.label
        : null,
    };
    const index = this.displayedValues.map((y) => y.courrierIndex).indexOf(this.selectedCard.courrierIndex);
    this.displayedValues[index] = this.selectedCard;
    this.displayedValues = [...this.displayedValues];
  }

  public modifyMultipleDatas(): void {
    this.openModificationCardModal = false;
    this.listOfIndexCardsSelected.forEach((bool, index) => {
      if (bool) {
        this.displayedValues[index].serviceId = this.selectedOption?.value ? this.selectedOption.value : this.displayedValues[index].serviceId;
        this.displayedValues[index].serviceLabel = this.selectedOption?.label ? this.selectedOption.label : this.displayedValues[index].serviceLabel;

        this.displayedValues[index].natureId = this.chosenNature ? this.chosenNature : this.displayedValues[index].natureId;
        this.displayedValues[index].natureLabel = this.chosenNature
          ? this.natures.find((nature) => nature.value === this.chosenNature)?.label
          : this.displayedValues[index].natureLabel;

        this.displayedValues[index].sourceId = this.chosenSource ? this.chosenSource : this.displayedValues[index].sourceId;
        this.displayedValues[index].sourceLabel = this.chosenSource
          ? this.sources.find((source) => source.value === this.chosenSource)?.label
          : this.displayedValues[index].sourceLabel;

        this.displayedValues[index].recommendedRef = this.chosenRecommendedRef
          ? this.chosenRecommendedRef
          : this.displayedValues[index].recommendedRef;

        this.displayedValues[index].scanningCenter = this.chosenScanningCenter
          ? this.chosenScanningCenter
          : this.displayedValues[index].scanningCenter;
        this.displayedValues[index].scanningCenterLabel = this.chosenScanningCenter
          ? this.scanningCenters.find((x) => x.codeQr === this.chosenScanningCenter)?.description
          : this.displayedValues[index].scanningCenterLabel;

        this.displayedValues[index].recipientId = this.chosenRecipient ? this.chosenRecipient : this.displayedValues[index].recipientId;
        this.displayedValues[index].recipientLabel = this.chosenRecipient
          ? this.recipients.find((x) => x.contactId === this.chosenRecipient)?.name
          : this.displayedValues[index].recipientLabel;

        this.displayedValues[index].classificationCodeId = this.chosenClassificationCode
          ? this.chosenClassificationCode
          : this.displayedValues[index].classificationCodeId;
        this.displayedValues[index].classificationCodeLabel = this.chosenClassificationCode
          ? this.classificationCodes.find((classificationCode) => classificationCode.value === this.chosenClassificationCode)?.label
          : this.displayedValues[index].classificationCodeLabel;
      }
    });
    this.displayedValues = [...this.displayedValues];
    this.listOfIndexCardsSelected = new Array(this.displayedValues.length).fill(false);
  }

  public emitCloseModal(dataToSendBack?: {
    splits: ScanSplit[];
    displayedValues: MassEncodeDisplayedDatas[];
    formValue: { dateEntree: Date; dateDocument: Date; dateEcheance: Date; datePostale: Date; remarques: string };
  }): void {
    this.closeModal.emit(dataToSendBack ? dataToSendBack : null);
  }

  public submitDatas(): void {
    const amountOfServicesFulfilled = this.displayedValues.filter((x) => x.serviceId).length;
    if (amountOfServicesFulfilled === this.displayedValues.length && this.form.value.dateEntree) {
      this.closeModal.emit({ splits: this.splits, displayedValues: this.displayedValues, formValue: this.form.value });
    } else {
      if (amountOfServicesFulfilled !== this.displayedValues.length) {
        this.toastr.warning(this.translater.translate('iScan.error.infosOnEachServiceRequired'));
      }
      if (!this.form.value.dateEntree) {
        this.toastr.warning(this.translater.translate('iScan.error.pleaseProvideAStartDate'));
      }
    }
  }
}
